module.exports = __webpack_public_path__ + "img/logo-for-animation_inverted.e765b266ea0b9658cefc0f4b5ca54da2.svg";